<!-- <div class="login-container">
  <mat-card class="login-card">
    <div class="top-section">

      <div class="overlay"></div>
      <div class="logos">
        <img src="https://cdn.prod.website-files.com/6502bcd4ecfd92517e4181eb/651510107292ae4c08a1e3b6_logo.png" alt="Perse Logo" class="logo" />
      </div>
      <h1>Join the 1.6m households and businesses being paid to save energy</h1>
      <p>You could earn between £500 and £50,000 and it’s free to participate.</p>
    </div>

    <div class="bottom-section">
      <h2>Login with registered email address</h2>
      <form [formGroup]="loginForm" (ngSubmit)="onSendMagicLink()">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Email</mat-label>
          <mat-icon matPrefix>mail</mat-icon>
          <input matInput formControlName="email" placeholder="Enter your email" />

         @if (loginForm.get('email')?.hasError('required')) {
          <mat-error>Email is required</mat-error>
         } @else if (loginForm.get('email')?.hasError('email')) {
          <mat-error>Please enter a valid email address</mat-error>
         } @else {
          <mat-error>Please try again</mat-error>
         }
        </mat-form-field>
        <button mat-raised-button color="primary" class="full-width" [disabled]="loginForm.invalid">
          Send Magic Link
        </button>
      </form>
      <div class="sign-up-link">
        Don't have an account yet? <a routerLink="/register">Sign up</a>
      </div>
    </div>
  </mat-card>
</div> -->

<!-- login.component.html -->
<div class="login-container">
  <mat-card class="login-card">
    <mat-card-header class="">
      <mat-card-title>Sign In</mat-card-title>
      <!-- <mat-card-subtitle>Please enter your registered email address to receive the secure magic link to access your account
      </mat-card-subtitle> -->
    </mat-card-header>
    <mat-card-content class="">
      <div class="subtitle">Please enter your registered email address to receive the secure magic link to access your account
      </div>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <!-- Email Field -->
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Email</mat-label>
          <input matInput placeholder="you@example.com" formControlName="email" type="email" required>
          <mat-error *ngIf="loginForm.get('email')?.hasError('required')">
            Email is required
          </mat-error>
          <mat-error *ngIf="loginForm.get('email')?.hasError('email')">
            Please enter a valid email
          </mat-error>
        </mat-form-field>

        <!-- Send Magic Link Button -->
        <button [disabled]="isRegInProgress" mat-flat-button color="primary" type="submit" [disabled]="loginForm.invalid">
          Send Magic Link
        </button>
      </form>
    </mat-card-content>
    <mat-card-actions class="justify-content-center">
      <div class="sign-up-link">
        Don't have an account yet? <a routerLink="/register">Sign up</a>
      </div>
    </mat-card-actions>
  </mat-card>
</div>
